import { lenisRef } from './lenisInstance'
import { easeInOutCubic } from './easing'

const NAV_OFFSET = 84
const MANUAL_DURATION = 1400

let manualRaf = 0

function manualScrollTo(targetY: number) {
  cancelAnimationFrame(manualRaf)
  const startY = window.scrollY
  const distance = targetY - startY
  const startTime = performance.now()

  function step(now: number) {
    const elapsed = now - startTime
    const t = Math.min(1, elapsed / MANUAL_DURATION)
    const eased = easeInOutCubic(t)
    window.scrollTo(0, startY + distance * eased)
    if (t < 1) {
      manualRaf = requestAnimationFrame(step)
    }
  }

  manualRaf = requestAnimationFrame(step)
}

/**
 * Lenis normally respects the OS "reduce motion" preference for everything,
 * including wheel/trackpad scrolling — which is the right call there. But a
 * menu click is an explicit navigation request, not ambient scrolling, so we
 * momentarily lift that restriction just for this one programmatic scroll.
 */
function lenisScrollTo(target: number | HTMLElement) {
  const lenis = lenisRef.current
  if (!lenis) return false

  const original = lenis.options.respectReducedMotion
  lenis.options.respectReducedMotion = false

  const restore = () => {
    lenis.options.respectReducedMotion = original
  }

  lenis.scrollTo(target, {
    offset: typeof target === 'number' ? undefined : -NAV_OFFSET,
    duration: 1.8,
    easing: easeInOutCubic,
    onComplete: restore,
  })

  // Safety net in case onComplete doesn't fire (e.g. interrupted scroll).
  window.setTimeout(restore, 2500)

  return true
}

export function scrollToHash(hash: string) {
  const id = hash.replace('#', '')
  const el = id ? document.getElementById(id) : null

  if (!el) {
    if (!lenisScrollTo(0)) manualScrollTo(0)
    return
  }

  if (!lenisScrollTo(el)) {
    const top = el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET
    manualScrollTo(top)
  }
}
